export default function FluidHeader() {
  const header = document.querySelector('.o-header')
  const hero = document.querySelector('.o-hero')

  const mainElement = document.querySelector('main')
  const secondSection = mainElement
    ? mainElement.querySelectorAll('section')[1]
    : null

  if (!header || !hero) return

  const checkScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop
    const windowHeight = window.innerHeight

    let visibility = 1 - scrollTop / windowHeight
    visibility = Math.max(0, Math.min(1, visibility))
    hero.style.setProperty('--hero-opacity', visibility.toFixed(2))
    header.style.setProperty('--header-opacity', visibility.toFixed(2))

    let shouldHaveBackground = scrollTop > windowHeight

    if (secondSection) {
      const secondSectionRect = secondSection.getBoundingClientRect()

      if (secondSectionRect.top <= 1) {
        shouldHaveBackground = true
      } else {
        shouldHaveBackground = false
      }
    }

    if (shouldHaveBackground) {
      header.classList.add('background')
    } else {
      header.classList.remove('background')
    }
  }

  window.addEventListener('scroll', checkScroll)
  checkScroll()
}
